import { toBackendLanguage } from './language'

function resolveI18nMap(m, lang) {
  if (!m || !lang) return null
  if (m[lang] != null && m[lang] !== '') return m[lang]
  const prefix = lang.split('_')[0]
  const keys = Object.keys(m)
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i]
    if (k === prefix || k.indexOf(prefix + '_') === 0 || k.indexOf(prefix + '-') === 0) {
      if (m[k] != null && m[k] !== '') return m[k]
    }
  }
  return null
}

/** 读取当前商城语言，映射为装修配置 code（zh_CN、en_US …） */
export function getDecorationLangCode(store) {
  try {
    const fromStore = store && store.getters && store.getters.currentLang
    if (fromStore) return toBackendLanguage(fromStore)
  } catch (e) { /* ignore */ }
  return 'zh_CN'
}

/** 字段级 i18n：xxxI18n[lang] ?? xxx */
export function pickI18nValue(container, key, lang) {
  if (!container) return ''
  const resolved = resolveI18nMap(container[key + 'I18n'], lang)
  if (resolved != null) return resolved
  return container[key]
}
